import React from 'react'

export default function Social(props) {
    return (
        <div className="social-icons-container">
            <div className="social-icons">
                <a href={props.data.facebook}>
                    {
                        props.data.facebook && props.data.facebook.length > 1 ? 
                            <span className={`facebook`}>
                                <i className="lab la-facebook-f"></i>
                            </span> : null
                    }
                </a>

                <a href={props.data.twitter}>
                    {
                        props.data.twitter && props.data.twitter.length > 1 ? 
                            <span className={`twitter`}>
                                <i className="lab la-twitter"></i>
                            </span> : null
                    }
                </a>

                <a href={props.data.instagram}>
                    {
                        props.data.instagram && props.data.instagram.length > 1 ? 
                            <span className={`instagram`}>
                                <i className="lab la-instagram"></i>
                            </span> : null
                    }
                </a>

                <a href={props.data.youtube}>
                    {
                        props.data.youtube && props.data.youtube.length > 1 ? 
                            <span className={`youtube`}>
                                <i className="lab la-youtube"></i>
                            </span> : null
                    }
                </a>

                <a href={props.data.vimeo}>
                    {
                        props.data.vimeo && props.data.vimeo.length > 1 ? 
                            <span className={`vimeo`}>
                                <i className="lab la-vimeo"></i>
                            </span> : null
                    }
                </a>
            </div>
        </div>
    )
}
